<template>
    <div class="newProductDetilsBanner-main banner-fade-in">
        <div class="newProductDetilsBanner-content">
            <div class="newProductDetilsBanner-content-center" ref="animate">
                <div class="title">
                    {{title}}
                </div>
                <div class="desc">
                    {{bannerInfo.desc}}
                </div>
            </div>
        </div>
        <div class="banner-content">
            <div class="all-list">
                <div class="item-time">
                    <div class="item" v-for="item in itemInfo.timeList" :key="item.id">
                        {{item.content}}
                    </div>
                </div>
                <div class="item-service">
                    <div class="item" v-for="item in itemInfo.serviceList" :key="item.id">
                        <span class="li"></span>{{item.content}}
                    </div>
                </div>
                <div class="item-location">
                    <span class="item" v-for="(item,index) in itemInfo.locationList" :key="item.id">
                        {{item}}<span class="border-span" v-show="index !== itemInfo.locationList.length - 1">|</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import bannerInfo from '/js/newProductDetils/bannerInfo.js'
export default {
    props:{
        routerId:String
    },
    data() {
        return {
            bannerInfo:{},
            itemInfo:{},
            titleList:[],
            title:'Western Sichuan',
            provinceId:0,
        }
    },
    mounted() {
        this.bannerInfo = bannerInfo.bannerInfo
        this.titleList = this.bannerInfo.titleList
        this.bannerInfo.itemList.map(item => {
            if(item.id == this.routerId){
                this.provinceId = item.provinceId
               this.itemInfo = item

            }
        })
        this.titleList.map(item => {
            if(item.provinceId == this.provinceId){
                this.title = item.title
            }
        })
        this.$nextTick(() => {
            const contentElement = this.$refs.animate;
            contentElement.classList.add('animate');
        })
    }
}
</script>
<style scoped lang="scss">
@import '/style/pc/common/animate.scss';
@import '/style/pc/common/fadeIn.scss';
@import '/style/phone/header/newProductDetilsBanner.scss';
.newProductDetilsBanner-main{
    margin-top: 5.5rem;
    width: 100%;
    .newProductDetilsBanner-content{
        width: 100%;
        margin: 0 auto;
        height: 39.375rem;
        background: url('/static/img/banner/newProductDetils.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        .newProductDetilsBanner-content-center{
            opacity: 0;
            transform: translateY(100%);
        }
        .title {
            color: #FFF;
            font-size: 4rem;
            font-weight: 700;
            line-height: 1.2;
            margin-bottom: 1.875rem;
            font-family: Butler;
        }
        .desc {
            color: #FFF;
            text-align: center;
            font-family: Inter;
            font-size: 1.25rem;
            font-weight: 300;
        }

    }
    .banner-content {
        background: #09080D;
        margin: 0 auto;

        .all-list {
            width: 75rem;
            padding: 2.5rem 0;
            margin: 0 auto;
            display: flex;
            color: #FFF;
            justify-content: space-between;
            align-items: center;
            font-feature-settings: 'liga' off, 'clig' off;
            font-size: 1.25rem;
            font-weight: 700;
            line-height: 1.2;

            .item {
                margin-bottom: 0.5rem;
            }

            .item-time {
                width: 12rem;
            }
            .item-service {
                width: 17.8125rem;
                .li {
                    display: inline-block;
                    width: 0.625rem;
                    height: 0.625rem;
                    background: #FFF;
                    border-radius: 50%;
                    margin-right: 0.625rem;

                }
            }

            .item-location {
                width: 33.125rem;
                display: flex;
                flex-wrap: wrap;
                color: #E5E5E7;
                font-family: Inter;
                font-size: 1.25rem;
                font-weight: 400;
                line-height: 1.5;
                text-transform: capitalize;
                .border-span {
                    margin: 0 0.375rem;
                }
            }
        }
    }
}
</style>